/** UI strings for the portal shell (toolbar) — not from CMS JSON. */
export const shellStrings = {
    en: {
        heroAgenciesLoadError: 'Could not load agencies.',
        heroDepartmentsLoadError: 'Could not load departments.',
        heroScrollTop: 'Top',
        heroScrollMore: 'More',
        heroAgencyCarouselPrev: 'Previous agencies',
        heroAgencyCarouselNext: 'Next agencies',
        heroAgencyCarouselPageLabel: 'Page {current} of {total}',
        heroAgencyCarouselDotAria: 'Go to page {page} of {total}',
        heroAgencyHoverFallback: 'View permits and services for this agency.',
        heroAgencyTooltipEyebrow: 'Agency',
        heroAgencyTooltipDepartmentLabel: 'Department',
        heroAgencyTooltipDepartmentLink: 'Department permits',
        /** Legacy tile caption — prefer inline `(count)` next to title; kept for patches */
        heroAgencyGroupedCount: '({count})',
        heroAgencyGroupedBadgeAria: '{count} related entries for this agency name',
        /** Empty: no intro line above the grouped list (popover header is title only) */
        heroAgencyGroupedTooltipLead: '',
        heroAgencyGroupedOpenPermits: 'Open permits',
        heroAgencyGroupedEntryLabel: 'Entry {current} of {total}',
        heroSearchSectionDepartments: 'Departments',
        heroSearchSectionAgencies: 'Agencies',
        heroSearchSectionPermits: 'Permits',
        heroSearchNoResults: 'No matches in loaded lists. Try another word or browse departments below.',
        heroSearchSelectHint: 'Select a result from the list below.',
        heroSearchOpenFullCatalog: 'Open full permit search…',
        heroSearchApplyNow: 'Apply Now',
    },
    es: {
        heroAgenciesLoadError: 'No se pudieron cargar las agencias.',
        heroDepartmentsLoadError: 'No se pudieron cargar los departamentos.',
        heroScrollTop: 'Arriba',
        heroScrollMore: 'Más',
        heroAgencyCarouselPrev: 'Agencias anteriores',
        heroAgencyCarouselNext: 'Siguientes agencias',
        heroAgencyCarouselPageLabel: 'Página {current} de {total}',
        heroAgencyCarouselDotAria: 'Ir a la página {page} de {total}',
        heroAgencyHoverFallback: 'Ver permisos y servicios de esta agencia.',
        heroAgencyTooltipEyebrow: 'Agencia',
        heroAgencyTooltipDepartmentLabel: 'Departamento',
        heroAgencyTooltipDepartmentLink: 'Permisos del departamento',
        heroAgencyGroupedCount: '({count})',
        heroAgencyGroupedBadgeAria: '{count} entradas relacionadas con este nombre de agencia',
        heroAgencyGroupedTooltipLead: '',
        heroAgencyGroupedOpenPermits: 'Abrir permisos',
        heroAgencyGroupedEntryLabel: 'Registro {current} de {total}',
        heroSearchSectionDepartments: 'Departamentos',
        heroSearchSectionAgencies: 'Agencias',
        heroSearchSectionPermits: 'Permisos',
        heroSearchNoResults: 'Sin coincidencias en las listas cargadas. Pruebe otra palabra o explore los departamentos abajo.',
        heroSearchSelectHint: 'Seleccione un resultado de la lista a continuación.',
        heroSearchOpenFullCatalog: 'Abrir búsqueda completa de permisos…',
        heroSearchApplyNow: 'Solicitar ahora',
    },
};
